import { defaultAgent, apiResponse } from '../helpers/web-agent';
import {
    GET_EQUIPMENT_GROUP_LIST, GET_EQUIPMENT_GROUP_LIST_REQUEST, EG_SELECTION, APPLY_EG_FILTERS,
    HANDLE_EG_DRAG_DROP, GET_OPTION_LIST_REQUEST, GET_OPTION_LIST, SET_FILTER_LIST, RESET_EG, VALIDATE_EG,
    UPDATE_EG_INFO, CREATE_EG, EG_SAVE_REQUEST, EG_SAVE_SUCCESS, EG_SAVE_FAILURE, CLEAR_EG_KANBAN
} from '../constants/action-types';
import { toastError, toastSuccess } from './toast';
import { tokenExpired } from './auth';
import { getSearchDateRange, isUUID, isToday } from '../helpers/common';
import { getUserId } from '../helpers/session';
import { EQUIPMENT_GROUP_EDITED, PERSONAL_CREATED } from '../constants/messages';
import { EG_OPTION_TYPES } from '../constants';

export const applyEgFilters = payload => ({ type: APPLY_EG_FILTERS, payload });

export const equipmentGroupListRequest = () => ({ type: GET_EQUIPMENT_GROUP_LIST_REQUEST });

export const equipmentGroupList = (data, range) => ({ type: GET_EQUIPMENT_GROUP_LIST, payload: data, range });

export const optionListRequest = (optionType) => ({ type: GET_OPTION_LIST_REQUEST, optionType });

export const optionList = ({ optionType, data = [] }) => ({ type: GET_OPTION_LIST, payload: data, optionType });

export const egSelection = (data) => ({ type: EG_SELECTION, payload: data });

export const handleDragDrop = (data) => ({ type: HANDLE_EG_DRAG_DROP, payload: data });

export const setFilterList = ({ optionType, oldFilterData = [], newFilterData = [] }) => ({ type: SET_FILTER_LIST, payload: { oldFilterData, newFilterData }, optionType });

export const editEquipmentGroup = (egId, data) => ({ type: UPDATE_EG_INFO, egId, payload: data });

export const createEquipmentGroup = (egId, data) => ({ type: CREATE_EG, egId, payload: data });

export const resetEg = () => ({ type: RESET_EG });

export const egSaveRequest = () => ({ type: EG_SAVE_REQUEST });

export const egSaveSuccess = () => ({ type: EG_SAVE_SUCCESS });

export const egSaveFailure = () => ({ type: EG_SAVE_FAILURE });

export const clearEgKanban = () => ({ type: CLEAR_EG_KANBAN });

export const validateEg = (data) => ({ type: VALIDATE_EG, payload: data });

export const saveEquipmentGroup = (success) => (dispatch, getState) => {
    const state = getState();
    const { kanban, filters: { farmId }, egList } = state.egKanban;
    const equipmentGroupsChanges = [];

    for (const egId in kanban) {
        if (!kanban[egId].isChanged || (EG_OPTION_TYPES.indexOf(egId) >= 0)) continue;
        const equipmentGroupInfo = kanban[egId];
        const isEditMode = egList.map(e => e.equipment_group_uuid).indexOf(egId) >= 0;

        const params = {
            farm_uuid: farmId,
            equipment_group_uuid: egId,
            name: equipmentGroupInfo.name,
            vehicle_equipment_uuid: isUUID(equipmentGroupInfo.list[0]) ? equipmentGroupInfo.list[0] : null,
            implement_equipment_uuid: isUUID(equipmentGroupInfo.list[1]) ? equipmentGroupInfo.list[1] : null,
            phone_device_uuid: isUUID(equipmentGroupInfo.list[2]) ? equipmentGroupInfo.list[2] : null,
            operator_uuid: isUUID(equipmentGroupInfo.list[3]) ? equipmentGroupInfo.list[3] : null,
            can_device_uuid: null,
            start_date: equipmentGroupInfo.startDate,
            equipment_group_mode_id: equipmentGroupInfo.modeTypeId,
            created_by: getUserId()
        };

        if (isEditMode) params.modified_by = getUserId();
        equipmentGroupsChanges.push(params);
    };

    dispatch(egSaveRequest());
    defaultAgent.put('/api/equipment/group/bulk/save', { farm_uuid: farmId, equipment_groups: equipmentGroupsChanges })
        .then(res => {
            const agentResult = apiResponse(res, {});
            if (agentResult.isUnauthorized) {
                dispatch(toastError(agentResult.message));
                dispatch(tokenExpired());
            } else if (agentResult.code === EQUIPMENT_GROUP_EDITED.code) {
                dispatch(egSaveSuccess());
                dispatch(success());
                dispatch(toastSuccess(agentResult.message));
            } else if (agentResult.message) {
                dispatch(egSaveFailure());
                dispatch(toastError(agentResult.message));
            }
        }).catch(ex => {
            dispatch(toastError(ex.message));
        });
}

export const getEquipmentGroupList = (params, cb = null) => (dispatch, getState) => {
    const search = getState().analyze.searchParams;
    const dateInfo = getSearchDateRange(search);

    const reqParams = {
        farm_uuid: params.farmId,
        from_date: dateInfo.from,
        to_date: dateInfo.to,
        crew: (params.crew || 1),
        device: (params.device || 1),
        ...params.planTypeId && params.planTypeId !== 10 && {
            plan_type_id: params.planTypeId
        }
    };

    dispatch(equipmentGroupListRequest());
    defaultAgent.get('/api/equipment/group/v1/list', reqParams)
        .then(res => {
            const agentResult = apiResponse(res, []);
            if (agentResult.isUnauthorized) {
                dispatch(toastError(agentResult.message));
                dispatch(tokenExpired());
            } else if (agentResult.message) {
                dispatch(toastError(agentResult.message));
                dispatch(equipmentGroupList());
            } else if (agentResult.data) {
                agentResult.data.sort((a, b) => (new Date(b.modified_date) - new Date(a.modified_date)));
                if (!!cb) cb(agentResult.data)
                dispatch(equipmentGroupList(agentResult.data, search.range));
            }
        }).catch(ex => {
            dispatch(toastError(ex.message));
            dispatch(equipmentGroupList());
        });
}

export const getEquipmentNameList = ({ farmId, equipmentType }) => (dispatch, getState) => {
    const search = getState().analyze.searchParams;

    let params = {
        farm_uuid: farmId,
        equipment_type: equipmentType,
        equipment_group_uuid: null
    };

    if (isToday(search.range)) params.include_deleted_equipments = 0;
    else params.include_deleted_equipments = 1;

    dispatch(optionListRequest(equipmentType));
    defaultAgent.get('/api/equipment/name/list', params)
        .then(res => {
            const agentResult = apiResponse(res, []);
            if (agentResult.isUnauthorized) {
                dispatch(toastError(agentResult.message));
                dispatch(tokenExpired());
            } else if (agentResult.message) {
                dispatch(toastError(agentResult.message));
                dispatch(optionList({ optionType: equipmentType }));
            } else if (agentResult.data) {
                dispatch(optionList({ optionType: equipmentType, data: agentResult.data }));
            }
        })
        .catch(ex => {
            dispatch(toastError(ex.message));
            dispatch(optionList({ optionType: equipmentType }));
        });
}

export const getDeviceList = ({ farmId, deviceType }) => {
    return dispatch => {
        dispatch(optionListRequest("device"));
        defaultAgent.get('/api/device/unassociate/list', { farm_uuid: farmId, device_type: deviceType, __version: 1 })
            .then(res => {
                const agentResult = apiResponse(res, []);
                if (agentResult.isUnauthorized) {
                    dispatch(toastError(agentResult.message));
                    dispatch(tokenExpired());
                } else if (agentResult.data) {
                    dispatch(optionList({ optionType: "device", data: agentResult.data }));
                } else if (agentResult.message) {
                    dispatch(toastError(agentResult.message));
                    dispatch(optionList({ optionType: "device" }));
                }
            })
            .catch(ex => {
                dispatch(toastError(ex.message));
                dispatch(optionList({ optionType: "device" }));
            });
    }
}

export const createPerson = (data, cb) => {
    return dispatch => {
        defaultAgent.post('/api/person/add', data)
            .then(res => {
                const agentResult = apiResponse(res, {});
                if (agentResult.isUnauthorized) {
                    dispatch(toastError(agentResult.message));
                    dispatch(tokenExpired());
                } else if (agentResult.code === PERSONAL_CREATED.code) {
                    if (cb) cb();
                    dispatch(toastSuccess(agentResult.message));
                    dispatch(getOperatorList({ farmId: data.farm_uuid }))
                } else if (agentResult.message) {
                    dispatch(toastError(agentResult.message));
                }
            }).catch(ex => {
                dispatch(toastError(ex.message));
            });
    }
}

export const createDevice = (data, cb) => {
    return dispatch => {
        defaultAgent.post('/api/hardware/save', data)
            .then(res => {
                const agentResult = apiResponse(res, {});
                if (agentResult.isUnauthorized) {
                    if (cb) cb(false);
                    dispatch(toastError(agentResult.message));
                    dispatch(tokenExpired());
                } else if (agentResult.code === 8008) {
                    if (cb) cb(true);
                    dispatch(toastSuccess(agentResult.message));
                    dispatch(getDeviceList({ farmId: data.farm_uuid, deviceType: 'phone' }));
                } else if (agentResult.message) {
                    if (cb) cb(false);
                    dispatch(toastError(agentResult.message));
                }
            }).catch(ex => {
                dispatch(toastError(ex.message));
            });
    }
}

export const getOperatorList = (params) => (dispatch, getState) => {
    const search = getState().analyze.searchParams;
    const dateInfo = getSearchDateRange(search);

    const reqParams = {
        farm_uuid: params.farmId,
        from_date: dateInfo.from,
        to_date: dateInfo.to,
        role: "operator"
    };

    dispatch(optionListRequest("operator"));
    defaultAgent.get('/api/person/v1/name/list', reqParams)
        .then(res => {
            const agentResult = apiResponse(res, []);
            if (agentResult.isUnauthorized) {
                dispatch(toastError(agentResult.message));
                dispatch(tokenExpired());
            } else if (agentResult.message) {
                dispatch(toastError(agentResult.message));
                dispatch(optionList({ optionType: "operator" }));
            } else if (agentResult.data) {
                agentResult.data.sort((a, b) => (new Date(b.modified_date) - new Date(a.modified_date)));
                dispatch(optionList({ optionType: "operator", data: agentResult.data }));
            }
        }).catch(ex => {
            dispatch(toastError(ex.message));
            dispatch(optionList({ optionType: "operator" }));
        });
}